import { useState } from "react";
import { CheckCircle2, Download, Loader2, Share, SquarePlus } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { isStandalone } from "@/lib/push";
import { Section } from "@/components/common/DetailFields";

export const ExportSection = () => {
  const [busy, setBusy] = useState(null);
  const download = async (format) => {
    setBusy(format);
    try {
      const r = await api.get("/export", { params: { format }, responseType: "blob" });
      const name = (r.headers["content-disposition"] || "").match(/filename="(.+)"/)?.[1] || `conecta.${format === "csv" ? "zip" : "json"}`;
      const url = URL.createObjectURL(r.data);
      Object.assign(document.createElement("a"), { href: url, download: name }).click();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
      toast.success("Exportación lista");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  const Btn = ({ format, label }) => (
    <button data-testid={`export-${format}-btn`} disabled={!!busy} onClick={() => download(format)} className="flex-1 py-3 rounded-xl c-card text-sm font-semibold flex items-center justify-center gap-1.5">
      {busy === format ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4 c-accent" />} {label}
    </button>
  );
  return (
    <Section title="Exportar mis datos" testid="config-export">
      <p className="text-xs c-muted mb-3">Descarga todo lo que puedes ver: contactos, negocios, comisiones, necesidades y capturas.</p>
      <div className="flex gap-2"><Btn format="json" label="JSON" /><Btn format="csv" label="CSV (zip)" /></div>
    </Section>
  );
};

const Step = ({ n, children }) => (
  <li className="flex gap-3 text-sm"><span className="w-6 h-6 shrink-0 rounded-full bg-[#0b2a47] text-white text-xs font-bold flex items-center justify-center">{n}</span><span className="pt-0.5">{children}</span></li>
);

export const InstallGuide = () => (
  <Section title="Instalar la app" testid="config-install">
    {isStandalone() ? (
      <p data-testid="install-done" className="text-sm flex items-center gap-2"><CheckCircle2 className="w-4 h-4 text-emerald-600" /> Ya estás usando la app instalada.</p>
    ) : (
      <div className="space-y-4">
        <div>
          <p className="text-sm font-semibold mb-2">iPhone / iPad (Safari)</p>
          <ol className="space-y-2" data-testid="install-ios-steps">
            <Step n={1}>Abre este enlace en <b>Safari</b>.</Step>
            <Step n={2}>Toca <b>Compartir</b> <Share className="inline w-4 h-4 -mt-1" /> en la barra de abajo.</Step>
            <Step n={3}>Elige <b>Agregar a inicio</b> <SquarePlus className="inline w-4 h-4 -mt-1" /> y toca <b>Agregar</b>.</Step>
            <Step n={4}>Abre CONECTA desde su icono. Para recibir avisos necesitas iOS 16.4 o superior.</Step>
          </ol>
        </div>
        <div>
          <p className="text-sm font-semibold mb-2">Android (Chrome)</p>
          <ol className="space-y-2"><Step n={1}>Toca el menú <b>⋮</b>.</Step><Step n={2}>Elige <b>Instalar app</b> o <b>Agregar a pantalla principal</b>.</Step></ol>
        </div>
      </div>
    )}
  </Section>
);
